import OnboardingWelcome from 'containers/OnboardingWelcome'
import OnboardingCompanyInfo from 'containers/OnboardingCompanyInfo'
import OnboardingPlaybookReadyStep from 'layouts/OnboardingPlaybookReadyStep';
import OnboardingSuccessStep from 'layouts/OnboardingSuccessStep';

export default Object.freeze([
  {
    route: '/welcome',
    component: OnboardingWelcome,
  },
  {
    route: '/company',
    component: OnboardingCompanyInfo,
  },
  {
    route: '/ready',
    component: OnboardingPlaybookReadyStep,
  },
  {
    route: '/woohoo',
    component: OnboardingSuccessStep,
  }
])



// WEBPACK FOOTER //
// ./src/flows/OnboardingFlow/routes.js